import {
  FETCH_EXCLUSION_SUBTYPE_REQUEST,
  FETCH_EXCLUSION_SUBTYPE_SUCCESS,
  FETCH_EXCLUSION_SUBTYPE_ERROR,
  SAVE_EXCLUSION_SUBTYPE_REQUEST,
  SAVE_EXCLUSION_SUBTYPE_SUCCESS,
  SAVE_EXCLUSION_SUBTYPE_ERROR,
  REMOVE_EXCLUSION_SUBTYPE_REQUEST,
  REMOVE_EXCLUSION_SUBTYPE_SUCCESS,
  REMOVE_EXCLUSION_SUBTYPE_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    deleted: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_EXCLUSION_SUBTYPE_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }
    case FETCH_EXCLUSION_SUBTYPE_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          records: action.payload,
          isFetching: false,
        },
      }
    case FETCH_EXCLUSION_SUBTYPE_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.payload,
          isFetching: false,
        },
      }
    case SAVE_EXCLUSION_SUBTYPE_REQUEST:
    case REMOVE_EXCLUSION_SUBTYPE_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }
    case SAVE_EXCLUSION_SUBTYPE_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          record: action.payload,
          error: null,
          updated: true,
          isUpdating: false,
        },
      }
    case SAVE_EXCLUSION_SUBTYPE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          isUpdating: false,
        },
      }
    case REMOVE_EXCLUSION_SUBTYPE_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          record: action.payload,
          error: null,
          deleted: true,
          isUpdating: false,
        },
      }
    case REMOVE_EXCLUSION_SUBTYPE_ERROR:
      return {
        ...state,
        edit: {
          record: {},
          error: action.payload,
          isUpdating: false,
          updated: false,
          deleted: false,
        },
      }
    default:
      return state
  }
}

export default record
